const SMPQuestDefaultStrategy = require("@/quest-editor/questImpl/strategies/SMPQuestDefaultStrategy");
class SMPQuestPlayMastermindNTimeDuringDayStrategy extends SMPQuestDefaultStrategy {

     initStartingValue() {
          this._challengeList = [50, 100,250, 300, 400, 550, 830];
     }

     increaseKPIGameplayReference() {
          //"jumpingLevel": 830, is max level defined that user can play reach to
          this.questContext.KPIGameplayBossLevel += this.questContext.JumpingLevel;
     }

     computeChallenge() {
          this.questContext.challengeTarget = this.getTargetBaseOnLevel(this.questContext.level);
     }

     computeLevelShouldAppear() {
          let shouldAppearAt = this.questContext.KPIGameplayBossLevel - this.questContext.challengeTarget - 1;
          if (shouldAppearAt < 1) shouldAppearAt = 1;
          this.questContext.KPIGameLevelShouldAppear = shouldAppearAt;
     }
}

module.exports = SMPQuestPlayMastermindNTimeDuringDayStrategy;